module.exports = __webpack_public_path__ + "img/gfish.ff3f7e1.webp";